import VehiclesMapContainer from './VehiclesMapContainer';

export default VehiclesMapContainer;
